.sectionDivider {
  margin-top: 8px;
  margin-bottom: 8px;
}
